module.exports = __webpack_public_path__ + "static/media/product-13.0c9adb2c.jpg";